// import { Card, IconButton } from "@mui/material";
// import SoftBox from "components/SoftBox";
// import SoftButton from "components/SoftButton";
// import SoftTypography from "components/SoftTypography";
// import SoftInput from "components/SoftInput";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import Swal from "sweetalert2";
// import { api } from "utils/Api";
// import SmartTableCard from "utils/Smart Table/SmartTableCard";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AdminUnitsPopupForm from "./AdminUnitsPopupForm";
// import DeleteForm from "layouts/admin/Organization/DeleteForm";
// import jwtDecode from "jwt-decode";
// import { getSecureItem } from "utils/SecureStorage";

// function AdminUnits() {
// const [allUnits, setAllUnits] = useState([]);
// const [filteredUnits, setFilteredUnits] = useState([]);
// const [searchTerm, setSearchTerm] = useState("");
// const [selectedUnit, setSelectedUnit] = useState(null);
// const [popupMode, setPopupMode] = useState("create");
// const [isPopupOpen, setIsPopupOpen] = useState(false);
// const [deletePopupOpen, setDeletePopupOpen] = useState(false);
// const navigate = useNavigate();
// const { propertyId, propertyDetailTab } = useParams();

// const fetchUnits = async () => {
//   try {
//     const response = await api.unit.getUnits();
//     // const filtered = response.filter((unit) => unit.property_id === Number(propertyId));

//     setAllUnits(response);
//     setFilteredUnits(response);

//   } catch (e) {
//     Swal.fire({
//       title: "Failed to load Units",
//       icon: "error",
//       toast: true,
//       timer: 2000,
//       position: "bottom-right",
//       showConfirmButton: false,
//     });
//   }
// };

// // const handleUnitNameClick = (unitId) => {
// // navigate(`/admin/properties/${propertyId}/units/${unitId}`);
// // }

// useEffect(() => {
//   fetchUnits();
// }, [propertyId]);

// // ================= SEARCH =================
// const handleSearch = (e) => {
//   const value = e.target.value;
//   setSearchTerm(value);

//   if (!value.trim()) {
//     setFilteredUnits(allUnits);
//     return;
//   }

//   const filtered = allUnits.filter((unit) =>
//     unit.name.toLowerCase().includes(value.toLowerCase())
//   );

//   setFilteredUnits(filtered);
// };

// // EDIT
// const handleEditUnit = (unit) => {
//   setSelectedUnit(unit);
//   setPopupMode("edit");
//   setIsPopupOpen(true);
// };

// // DELETE
// const handleDeleteUnit = async (id) => {
//   try {
//     await api.unit.deleteUnit(id);
//     fetchUnits();
//   } catch (e) {
//     Swal.fire({
//       title: "Failed to delete Unit",
//       icon: "error",
//       toast: true,
//       timer: 2000,
//       position: "bottom-right",
//       showConfirmButton: false,
//     });
//   }
// };

// return (
//   <>
//     <Card>
//       <SmartTableCard
//         title={<h4>Units in Property</h4>}
//         headerRight={[
//           <SoftButton
//             key="add-unit"
//             variant="outlined"
//             color="info"
//             size="small"
//             onClick={() => {
//               setSelectedUnit(null);
//               setIsPopupOpen(true);
//               setPopupMode("create");
//             }}
//           >
//             Add Unit
//           </SoftButton>,

//           <SoftInput
//             key="search-unit"
//             placeholder="Search Units"
//             value={searchTerm}
//             onChange={handleSearch}
//             size="small"
//           />,
//         ]}

//         columns={[
//           { label: "Unit Name", key: "UnitName" },
//           { label: "Description", key: "Description", align: "center" },
//           { label: "Unit Code", key: "UnitCode", align: "center" },
//           { label: "Status", key: "Status", align: "center" },
//           { label: "Actions", key: "Actions", align: "center" },
//         ]}

//         rows={filteredUnits.map((unit) => ({
//           UnitName: (
//             <SoftTypography variant="button" sx={{ fontWeight: 600}}
//             // onClick={() => handleUnitNameClick(unit.id)}
//             >
//               {unit.name}
//             </SoftTypography>
//           ),
//           Description: unit.description,
//           UnitCode: unit.unit_code,
//           Status: unit.active ? "Active" : "Inactive",

//           Actions: (
//             <SoftBox display="flex" justifyContent="center" gap="8px">

//               <IconButton
//                 onClick={() => handleEditUnit(unit)}
//                 sx={{
//                   border: "1px solid #D0D5DD",
//                   backgroundColor: "#F9FAFB",
//                   width: 34,
//                   height: 34,
//                 }}>
//                 <EditIcon fontSize="small" />
//               </IconButton>
//               <IconButton
//                 onClick={() => {
//                   setSelectedUnit(unit);
//                   setDeletePopupOpen(true);
//                 }}
//                 sx={{
//                   border: "1px solid #FECACA",
//                   backgroundColor: "#FEF2F2",
//                   width: 34,
//                   height: 34,
//                 }}>
//                 <DeleteIcon fontSize="small" />
//               </IconButton>
//             </SoftBox>
//           ),
//         }))}/>
//     </Card>

//     {isPopupOpen && (
//       <AdminUnitsPopupForm
//         mode={popupMode}
//         unit={selectedUnit}
//         refreshUnits={fetchUnits}
//         propertyId={propertyId}
//         onClose={() => {
//           setIsPopupOpen(false);
//         }}
//       />
//     )}

//     {deletePopupOpen && (
//       <DeleteForm
//         data={selectedUnit}
//         type="Unit"
//         displayField="name"
//         onClose={() => setDeletePopupOpen(false)}
//         onDelete={async (id) => {
//           await handleDeleteUnit(id);
//           setDeletePopupOpen(false);
//         }}
//       />
//     )}
//   </>
// );
// }

// export default AdminUnits;

import { Card, IconButton, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { api } from "utils/Api";
import SmartTableCard from "utils/Smart Table/SmartTableCard";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AdminUnitsPopupForm from "./AdminUnitsPopupForm";
import DeleteForm from "layouts/admin/Organization/DeleteForm";
import PropTypes from "prop-types";
import { showSuccess } from "utils/messageAlerts";
import { canUpdate } from "utils/permissionManager";
import { canDelete } from "utils/permissionManager";
import { canCreate } from "utils/permissionManager";
import { useAuth } from "context/AuthContext";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getSecureItem } from "utils/SecureStorage";
import ConfirmDialog from "utils/ConfirmDialog";

// propertyId comes ONLY from props — NEVER from useParams
function AdminUnits({ propertyId, orgId, roleId }) {
  const [allUnits, setAllUnits] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [popupMode, setPopupMode] = useState("create");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isAdmin, isManager } = useAuth();
  const rolesId = JSON.parse(getSecureItem("currentUser"))?.role_id;
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: null,
    property: null,
  });

  const fetchUnits = async () => {
    if (!propertyId || !orgId || !roleId) return;

    try {
      setLoading(true);

      const payload = {
        property_id: propertyId,
        org_id: orgId,
        role_id: roleId,
      };
      const response = await api.multiOrgProperty.postMultiOrgUnits(payload);

      setAllUnits(response);
      setFilteredUnits(response);
      setSearchTerm("");
    } catch (e) {
      setAllUnits([]);
      setFilteredUnits([]);
    } finally {
      setLoading(false);
    }
  };

  // Re-fetch whenever propertyId prop changes
  useEffect(() => {
    if (propertyId && orgId && roleId) {
      fetchUnits();
    }
  }, [propertyId, orgId, roleId]);

  // Search filters already-fetched units only
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value.trim()) {
      setFilteredUnits(allUnits);
      return;
    }

    const filtered = allUnits.filter((unit) =>
      unit.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredUnits(filtered);
  };

  const handleEditUnit = (unit) => {
    setSelectedUnit(unit);
    setPopupMode("edit");
    setIsPopupOpen(true);
  };

  const handleDeleteUnit = async (id) => {
    try {
      await api.unit.deleteUnit(id, orgId);
      showSuccess("Unit Soft Deleted Successfully.");
      fetchUnits();
    } catch (e) {}
  };

  const canEdit = canUpdate("Unit");
  const canRemove = canDelete("Unit");
  const showActionsColumn = canEdit || canRemove;

  const handleUnitActionClick = (unit, action) => {
    setConfirmDialog({
      open: true,
      type: action,
      unit,
    });
  };

  const handleConfirmAction = async () => {
    const { unit, type } = confirmDialog;

    try {
      if (type === "delete") {
        await api.unit.hardDeleteUnit(unit.id, orgId);
        showSuccess("Unit permanently deleted successfully");
      } else {
        await api.unit.restoreUnit({
          unit_id: unit.id,
          property_id: unit.property_id,
          current_user_role_id: rolesId,
        });
        showSuccess("Unit restored successfully");
      }

      fetchUnits();
    } catch (e) {}

    setConfirmDialog({ open: false, type: null, property: null });
  };

  return (
    <>
      <Card>
        <SmartTableCard
          title={<h4>Units in Property</h4>}
          headerRight={[
            canCreate("Unit") && (
              <SoftButton
                key="add-unit"
                variant="outlined"
                color="info"
                size="small"
                onClick={() => {
                  setSelectedUnit(null);
                  setIsPopupOpen(true);
                  setPopupMode("create");
                }}
              >
                Add Unit
              </SoftButton>
            ),
            <SoftInput
              key="search-unit"
              placeholder="Search Units"
              value={searchTerm}
              onChange={handleSearch}
              size="small"
            />,
          ]}
          columns={[
            { label: "Unit Name", key: "UnitName" },
            { label: "Description", key: "Description", align: "center" },
            { label: "Unit Code", key: "UnitCode", align: "center" },
            ...(isAdmin || isManager ? [{ label: "Active", key: "Active", align: "center" }] : []),
            ...(showActionsColumn ? [{ label: "Actions", key: "Actions", align: "center" }] : []),
          ]}
          rows={filteredUnits.map((unit) => {
            const isInactive = !unit.active;

            return {
              UnitName: (
                <SoftTypography variant="button" sx={{ fontWeight: 600 }}>
                  {unit.name}
                </SoftTypography>
              ),
              Description: unit.description,
              UnitCode: unit.unit_code,
              ...(isAdmin || isManager
                ? {
                    Active: unit.active ? (
                      <SoftTypography variant="button" color="success" fontWeight="bold">
                        Yes
                      </SoftTypography>
                    ) : isAdmin || isManager ? (
                      <SoftBox display="flex" justifyContent="center" gap="6px">
                        {/* Restore */}
                        <Tooltip title="Restore Unit" arrow>
                          <IconButton
                            onClick={() => handleUnitActionClick(unit, "restore")}
                            sx={{
                              width: 30,
                              height: 30,
                              color: "#16A34A",
                              backgroundColor: "#ECFDF5",
                              "&:hover": {
                                backgroundColor: "#D1FAE5",
                                transform: "scale(1.1)",
                              },
                            }}
                          >
                            <RestoreIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>

                        {/* Delete */}
                        <Tooltip title="Delete Unit Permanently" arrow>
                          <IconButton
                            onClick={() => handleUnitActionClick(unit, "delete")}
                            sx={{
                              width: 30,
                              height: 30,
                              color: "#DC2626",
                              backgroundColor: "#FEF2F2",
                              "&:hover": {
                                backgroundColor: "#FEE2E2",
                                transform: "scale(1.1)",
                              },
                            }}
                          >
                            <DeleteForeverIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </SoftBox>
                    ) : (
                      <SoftTypography variant="button" color="error" fontWeight="bold">
                        No
                      </SoftTypography>
                    ),
                  }
                : {}),
              ...(showActionsColumn && {
                Actions: (
                  <SoftBox display="flex" justifyContent="center" gap="8px">
                    {canEdit && (
                      <IconButton
                        onClick={() => handleEditUnit(unit)}
                        disabled={isInactive}
                        sx={{
                          border: "1px solid #D0D5DD",
                          backgroundColor: "#F9FAFB",
                          width: 34,
                          height: 34,
                          "& svg": { fontSize: 18 },
                          color: "#475467",
                          "&:hover": {
                            backgroundColor: "#E0F2FE",
                            borderColor: "#38BDF8",
                            color: "#0284C7",
                          },
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                    {canRemove && (
                      <IconButton
                        onClick={() => {
                          setSelectedUnit(unit);
                          setDeletePopupOpen(true);
                        }}
                        disabled={isInactive}
                        sx={{
                          border: "1px solid #FECACA",
                          backgroundColor: "#FEF2F2",
                          width: 34,
                          height: 34,
                          "& svg": { fontSize: 18 },
                          color: "#B91C1C",
                          "&:hover": {
                            backgroundColor: "#FEE2E2",
                            borderColor: "#F87171",
                            color: "#991B1B",
                          },
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    )}
                  </SoftBox>
                ),
              }),
            };
          })}
        />
      </Card>

      <ConfirmDialog
        open={confirmDialog.open}
        type={confirmDialog.type}
        title={confirmDialog.type === "delete" ? "Delete Unit" : "Restore Unit"}
        description={
          confirmDialog.type === "delete"
            ? "This will permanently delete the unit. This action cannot be undone."
            : "Are you sure you want to restore this unit?"
        }
        confirmText={confirmDialog.type === "delete" ? "Delete Permanently" : "Restore"}
        onClose={() => setConfirmDialog({ open: false, type: null, unit: null })}
        onConfirm={handleConfirmAction}
      />

      {/*  propertyId from props — NOT from useParams */}
      {isPopupOpen && (
        <AdminUnitsPopupForm
          mode={popupMode}
          unit={selectedUnit}
          refreshUnits={fetchUnits}
          propertyId={propertyId}
          onClose={() => setIsPopupOpen(false)}
        />
      )}

      {deletePopupOpen && (
        <DeleteForm
          data={selectedUnit}
          type="Unit"
          displayField="name"
          onClose={() => setDeletePopupOpen(false)}
          onDelete={async (id) => {
            await handleDeleteUnit(id);
            setDeletePopupOpen(false);
          }}
        />
      )}
    </>
  );
}

AdminUnits.propTypes = {
  propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AdminUnits;
